export enum AiReportDataType {
  Summary = 'summary',
  Decompiled_disassembly_section = 'decompiled_disassembly_section',
}

export type AiReportDecompiledData = {
  functions: null | string[]
  summary: null | string
  content: null | string
}

export type AiReportData = {
  data: string | AiReportDecompiledData
  data_type: AiReportDataType
  source_id: string | null
  created_date: string
}
